import {
  CIMSPage,
  CIMSPageItem,
  alphabeticalCompare,
} from '@cims-online/shared'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import ProjectLink from 'components/ProjectLink'
import { ProjectToInternal } from '../InternalConnectionsContext'
import { useGroupColumn } from '../../../hooks/useGroupColumn'
import { HelpMessage } from 'utils/constants'
import { Tooltip } from 'antd'

export function useColumns(): CIMSColumn<ProjectToInternal>[] {
  return [
    {
      title: 'Modules',
      help: HelpMessage.PayItems.Manage.Internals.Modules,
      width: 300,
      render: ({ internal: { classType, module } }) => {
        let item: CIMSPageItem | undefined = undefined
        if (classType === 'ConstructionAdminSubmittal')
          item = CIMSPage.CASTracker
        else if (classType === 'ConcreteTestSet')
          item = CIMSPage.ConcreteTestSets
        else if (classType === 'DesignSubmittal') item = CIMSPage.DSLog
        else if (classType === 'FieldDesignChange') item = CIMSPage.FDCTracker
        else if (classType === 'Issue') item = CIMSPage.IssueTracker
        else if (classType === 'EngineeringJudgement') item = CIMSPage.EJLog
        if (!item)
          return <Tooltip title="Unknown CIMSPage">{module.name}</Tooltip>
        return <ProjectLink item={item}>{module.name}</ProjectLink>
      },
      sort: {
        with: 'callback',
        onCompare: (a, b) =>
          alphabeticalCompare(a.internal.module, b.internal.module, 'name'),
        default: 'ascend',
      },
      filter: {
        type: 'default',
        with: 'items',
        items: (records) =>
          records.map(({ internal, id }) => ({
            text: internal.module.name,
            value: id,
          })),
        key: 'id',
      },
    },
    useGroupColumn(),
  ]
}
